/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type TeamOffensiveStatsDisplayQueryVariables = {|
  teamId: string,
  seasonID?: ?string,
|};
export type TeamOffensiveStatsDisplayQueryResponse = {|
  +nflTeamWeekStats: ?$ReadOnlyArray<?{|
    +week: {|
      +week: number
    |},
    +team: {|
      +city: ?string,
      +abbreviation: string,
    |},
    +opp: {|
      +city: ?string,
      +abbreviation: string,
    |},
    +passAtt: number,
    +rushAtt: number,
    +passYds: number,
    +rushYds: number,
    +timeOfPos: number,
  |}>,
  +nflTeamOpponentWeekStats: ?$ReadOnlyArray<?{|
    +week: {|
      +week: number
    |},
    +team: {|
      +city: ?string,
      +abbreviation: string,
    |},
    +opp: {|
      +city: ?string,
      +abbreviation: string,
    |},
    +passAtt: number,
    +rushAtt: number,
    +passYds: number,
    +rushYds: number,
    +timeOfPos: number,
  |}>,
|};
export type TeamOffensiveStatsDisplayQuery = {|
  variables: TeamOffensiveStatsDisplayQueryVariables,
  response: TeamOffensiveStatsDisplayQueryResponse,
|};
*/


/*
query TeamOffensiveStatsDisplayQuery(
  $teamId: ID!
  $seasonID: ID
) {
  nflTeamWeekStats(teamId: $teamId, seasonId: $seasonID) {
    week {
      week
      id
    }
    team {
      city
      abbreviation
      id
    }
    opp {
      city
      abbreviation
      id
    }
    passAtt
    rushAtt
    passYds
    rushYds
    timeOfPos
    id
  }
  nflTeamOpponentWeekStats(teamId: $teamId, seasonId: $seasonID) {
    week {
      week
      id
    }
    team {
      city
      abbreviation
      id
    }
    opp {
      city
      abbreviation
      id
    }
    passAtt
    rushAtt
    passYds
    rushYds
    timeOfPos
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "seasonID"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "teamId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "seasonId",
    "variableName": "seasonID"
  },
  {
    "kind": "Variable",
    "name": "teamId",
    "variableName": "teamId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "week",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "city",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "abbreviation",
  "storageKey": null
},
v6 = [
  (v4/*: any*/),
  (v5/*: any*/)
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "passAtt",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rushAtt",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "passYds",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rushYds",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timeOfPos",
  "storageKey": null
},
v12 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "NFLStatWeekType",
    "kind": "LinkedField",
    "name": "week",
    "plural": false,
    "selections": [
      (v3/*: any*/)
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "NFLStatTeamType",
    "kind": "LinkedField",
    "name": "team",
    "plural": false,
    "selections": (v6/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "NFLStatTeamType",
    "kind": "LinkedField",
    "name": "opp",
    "plural": false,
    "selections": (v6/*: any*/),
    "storageKey": null
  },
  (v7/*: any*/),
  (v8/*: any*/),
  (v9/*: any*/),
  (v10/*: any*/),
  (v11/*: any*/)
],
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v14 = [
  (v4/*: any*/),
  (v5/*: any*/),
  (v13/*: any*/)
],
v15 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "NFLStatWeekType",
    "kind": "LinkedField",
    "name": "week",
    "plural": false,
    "selections": [
      (v3/*: any*/),
      (v13/*: any*/)
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "NFLStatTeamType",
    "kind": "LinkedField",
    "name": "team",
    "plural": false,
    "selections": (v14/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "NFLStatTeamType",
    "kind": "LinkedField",
    "name": "opp",
    "plural": false,
    "selections": (v14/*: any*/),
    "storageKey": null
  },
  (v7/*: any*/),
  (v8/*: any*/),
  (v9/*: any*/),
  (v10/*: any*/),
  (v11/*: any*/),
  (v13/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "TeamOffensiveStatsDisplayQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "NFLTeamWeekStatsType",
        "kind": "LinkedField",
        "name": "nflTeamWeekStats",
        "plural": true,
        "selections": (v12/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "NFLTeamWeekStatsType",
        "kind": "LinkedField",
        "name": "nflTeamOpponentWeekStats",
        "plural": true,
        "selections": (v12/*: any*/),
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "TeamOffensiveStatsDisplayQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "NFLTeamWeekStatsType",
        "kind": "LinkedField",
        "name": "nflTeamWeekStats",
        "plural": true,
        "selections": (v15/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "NFLTeamWeekStatsType",
        "kind": "LinkedField",
        "name": "nflTeamOpponentWeekStats",
        "plural": true,
        "selections": (v15/*: any*/),
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4ae6fdfd5b0471dac08e83567f5f8c08",
    "id": null,
    "metadata": {},
    "name": "TeamOffensiveStatsDisplayQuery",
    "operationKind": "query",
    "text": "query TeamOffensiveStatsDisplayQuery(\n  $teamId: ID!\n  $seasonID: ID\n) {\n  nflTeamWeekStats(teamId: $teamId, seasonId: $seasonID) {\n    week {\n      week\n      id\n    }\n    team {\n      city\n      abbreviation\n      id\n    }\n    opp {\n      city\n      abbreviation\n      id\n    }\n    passAtt\n    rushAtt\n    passYds\n    rushYds\n    timeOfPos\n    id\n  }\n  nflTeamOpponentWeekStats(teamId: $teamId, seasonId: $seasonID) {\n    week {\n      week\n      id\n    }\n    team {\n      city\n      abbreviation\n      id\n    }\n    opp {\n      city\n      abbreviation\n      id\n    }\n    passAtt\n    rushAtt\n    passYds\n    rushYds\n    timeOfPos\n    id\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '9beb7b4393852ab9ec2477d6de47fc98';

module.exports = node;
